/**
 * Convert string into de-capitalized case.
 * First letters will be lowercase.
 * @memberof module:stringcase/lib
 * @function decapitalcase
 * @param {string} str - String to convert.
 * @returns {string} Capital case string.
 */
'use strict';

var lowercase = require('./lowercase');
/** @lends capitalcase */


function capitalcase(str) {
  str = String(str);

  if (!str) {
    return str;
  }

  return lowercase(str[0]) + str.slice(1);
}

module.exports = capitalcase;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImRlY2FwaXRhbGNhc2UuanMiXSwibmFtZXMiOlsibG93ZXJjYXNlIiwicmVxdWlyZSIsImNhcGl0YWxjYXNlIiwic3RyIiwiU3RyaW5nIiwic2xpY2UiLCJtb2R1bGUiLCJleHBvcnRzIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7QUFTQTs7QUFFQSxJQUFNQSxTQUFTLEdBQUdDLE9BQU8sQ0FBQyxhQUFELENBQXpCO0FBRUE7OztBQUNBLFNBQVNDLFdBQVQsQ0FBc0JDLEdBQXRCLEVBQTJCO0FBQ3pCQSxFQUFBQSxHQUFHLEdBQUdDLE1BQU0sQ0FBQ0QsR0FBRCxDQUFaOztBQUNBLE1BQUksQ0FBQ0EsR0FBTCxFQUFVO0FBQ1IsV0FBT0EsR0FBUDtBQUNEOztBQUNELFNBQU9ILFNBQVMsQ0FBQ0csR0FBRyxDQUFFLENBQUYsQ0FBSixDQUFULEdBQXNCQSxHQUFHLENBQUNFLEtBQUosQ0FBVSxDQUFWLENBQTdCO0FBQ0Q7O0FBRURDLE1BQU0sQ0FBQ0MsT0FBUCxHQUFpQkwsV0FBakIiLCJzb3VyY2VSb290IjoiLi4vLi4vbGliIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb252ZXJ0IHN0cmluZyBpbnRvIGRlLWNhcGl0YWxpemVkIGNhc2UuXG4gKiBGaXJzdCBsZXR0ZXJzIHdpbGwgYmUgbG93ZXJjYXNlLlxuICogQG1lbWJlcm9mIG1vZHVsZTpzdHJpbmdjYXNlL2xpYlxuICogQGZ1bmN0aW9uIGRlY2FwaXRhbGNhc2VcbiAqIEBwYXJhbSB7c3RyaW5nfSBzdHIgLSBTdHJpbmcgdG8gY29udmVydC5cbiAqIEByZXR1cm5zIHtzdHJpbmd9IENhcGl0YWwgY2FzZSBzdHJpbmcuXG4gKi9cblxuJ3VzZSBzdHJpY3QnXG5cbmNvbnN0IGxvd2VyY2FzZSA9IHJlcXVpcmUoJy4vbG93ZXJjYXNlJylcblxuLyoqIEBsZW5kcyBjYXBpdGFsY2FzZSAqL1xuZnVuY3Rpb24gY2FwaXRhbGNhc2UgKHN0cikge1xuICBzdHIgPSBTdHJpbmcoc3RyKVxuICBpZiAoIXN0cikge1xuICAgIHJldHVybiBzdHJcbiAgfVxuICByZXR1cm4gbG93ZXJjYXNlKHN0clsgMCBdKSArIHN0ci5zbGljZSgxKVxufVxuXG5tb2R1bGUuZXhwb3J0cyA9IGNhcGl0YWxjYXNlXG4iXX0=